export default "__VITE_ASSET__e1540653__"